import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.addressy.com/Capture/Interactive'
});
const Key = process.env.VUE_APP_LOQATE_API_KEY;
const IsMiddleware = false;
const Origin = '';
const Countries = 'GBR';
const Limit = '10';
const Language = 'en-gb';

api.interceptors.request.use(config => {
  const existingParams = config.params || {};
  config.params = {
    ...existingParams,
    Key
  };
  return config;
});

export default {
  search(text) {
    return new Promise((resolve, reject) => {
      api
        .get('Find/v1.10/json3.ws', {
          params: {
            Text: text,
            IsMiddleware,
            Origin,
            Countries,
            Limit,
            Language
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  searchContainer(text, container) {
    return new Promise((resolve, reject) => {
      api
        .get('Find/v1.10/json3.ws', {
          params: {
            Text: text,
            Container: container,
            Limit: 250,
            IsMiddleware,
            Origin,
            Countries,
            Language
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  retrieve(id) {
    return new Promise((resolve, reject) => {
      api
        .get('Retrieve/v1/json3.ws', {
          params: {
            Id: id
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
